export default "__VITE_ASSET__Cf8_OgHD__"